module.exports = __webpack_public_path__ + "img/resource-tech-image-62.85d86e88.jpg";